import GS from "@/src/scripts/ts/GlobalSetting";
import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Emitter } from "strict-event-emitter";
import EZAlert from "../../popups/EZAlert";

export default class Captcha extends ComponentBase {
  id: string = null;
  token: string = undefined;
  emitter: Emitter<{ "token-change": [token: string] }>

  constructor(elem: ComponentElem) {
    super(elem);
    this.emitter = new Emitter();
  }

  ready() {
    return new Promise((resolve) => {
      if (!window._captchaApiLoaded_) {
        EZAlert.pending();
        window._afterCaptchaApiLoaded_ = () => {
          EZAlert.pending(false);
          resolve(true);
        };
      } else {
        resolve(true);
      }
    });
  }

  reset() {
    this.token = null;
    let elem = this.$root[0];
    if (this.id !== null) {
      window.grecaptcha.reset(this.id);
    } else {
      this.id = window.grecaptcha.render(elem, {
        'sitekey': GS.setting.recaptchaSiteKey,
        'theme': 'light',
        'callback': (token: string) => {
          this.token = token;
          this.emitter.emit("token-change", this.token);
        },
        "expired-callback": () => {
          console.error("recaptcha timeout");
          this.token = null;
          this.emitter.emit("token-change", this.token);
        }
      });
    }
  }
}
